export default __webpack_public_path__ + "static/media/chair.ad2e84cf.webp";